import HttpClient from "@lib/http-client";

export default class DocumentsService extends HttpClient {
  constructor(...args) {
    super(...args);
  }

  async getDocuments({ productId, organizationCode }) {
    return this.http.get("/documents", {
      params: { product_id: productId, organization_code: organizationCode },
    });
  }

  downloadDocuments({ productId, levelId, itemIds, organizationCode }) {
    return this.downloadBlob(
      {
        method: "get",
        url: "/documents/download",
        params: {
          product_id: productId,
          level_id: levelId,
          item_ids: itemIds,
          organization_code: organizationCode,
        },
        paramsSerializer: { indexes: null },
      },
      `curriculum-resources-${levelId}`,
      "zip",
      {
        preferContentDispositionFilename: true,
        blobOptions: { type: "application/zip" },
      }
    );
  }

  async requestDocumentsDownload({ productId, itemIds, organizationCode }) {
    return this.http.post("/documents/download/request", {
      product_id: productId,
      item_ids: itemIds ?? null,
      organization_code: organizationCode,
    });
  }
}
